import GoogleMapsAPI from './GoogleMapsAPI';
import ChromeAutoCompleteHelper from './ChromeAutoCompleteHelper';

class PharmacyLookup {
	constructor(el) {
		this.el = el;
		this.input = el.querySelector('.field-input');
		this.autoFields = el.querySelector('.js-pharmacy-lookup__auto');
		this.manualFields = el.querySelector('.js-pharmacy-lookup__manual');
		this.cantFindCTA = el.querySelector('.field__link a');
		this.closeCTA = el.querySelector('.js-pharmacy-lookup__close-btn');
		this.autoComplete = null;
		this.init();
	}

	init = () => {
		ChromeAutoCompleteHelper.hideAutocomplete(this.input);
		GoogleMapsAPI.load().then(this.attachHandlers);
	};

	attachHandlers = () => {
		// Remove the chrome autocomplete
		this.createAutocomplete();
		this.cantFindCTA.addEventListener('click', e => {
			e.preventDefault();
			this.showManualFields();
		});
		this.closeCTA.addEventListener('click', this.hideManualFields);
	};

	prepareForSubmit = () => {
		// Restore the autocomplete stuff
		ChromeAutoCompleteHelper.showAutocomplete(this.input);
	};

	createAutocomplete = () => {
		this.autoComplete = new window.google.maps.places.Autocomplete(
			this.input,
			{
				types: ['establishment'],
				componentRestrictions: { country: 'au' }
			}
		);

		// Limit results to Sydney
		let circle = new window.google.maps.Circle({
			center: {
				lat: -33.883299,
				lng: 151.195955
			},
			radius: 202484
		});
		this.autoComplete.setBounds(circle.getBounds());
	};

	showManualFields = () => {
		this.autoFields.classList.remove('is-visible');
		this.manualFields.classList.add('is-visible');
	};

	hideManualFields = () => {
		this.autoFields.classList.add('is-visible');
		this.manualFields.classList.remove('is-visible');
	};
}

export default PharmacyLookup;
